import { render, staticRenderFns } from "./AuthorSocials.vue?vue&type=template&id=9e815f70&scoped=true&"
import script from "./AuthorSocials.vue?vue&type=script&lang=js&"
export * from "./AuthorSocials.vue?vue&type=script&lang=js&"
import style0 from "./AuthorSocials.vue?vue&type=style&index=0&id=9e815f70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e815f70",
  null
  
)

export default component.exports